import { httpClient } from "../../../lib/http/axios";
import { mapRailwayTransferResult, type RailwayTransferSearchResponseRaw } from "../api/adapters";
import type { RailwayQuery, RailwayTransferSearchResult } from "../types";

/** 只查询独立中转入口；后端统一负责有界取数，前端不叠加自动重试。 */
export async function getRailwayTransfers(query: RailwayQuery, signal?: AbortSignal): Promise<RailwayTransferSearchResult> {
  const response = await httpClient.get<RailwayTransferSearchResponseRaw>("/itineraries/transport/railway/transfers", {
    params: { from_station_ids: query.fromStationIds, to_station_ids: query.toStationIds,
      date: query.date, query_scope: query.queryScope ?? "auto" },
    paramsSerializer: { indexes: null }, "axios-retry": { retries: 0 }, signal,
  });
  const raw = response.data.data;
  return mapRailwayTransferResult(raw);
}
